
import {initWebComponent} from "@/helpers/web-component-helper";
import {resetMap} from "@/helpers/ol/ol-map-helper";
import {OlZoomInComponent} from "@/components/ol/buttons/ol-zoom-in-component";
import {RightMouseButtonComponent} from "@/components/bookmark/right-mouse-button-component";
import {initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {getMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";

export class BookmarkRightMouseButtonsComponent extends HTMLElement {
    constructor(){
        super();

        const settings = window.settings
        const template = document.createElement('template');
        let innerHTML = `
            <div class="card m-3 bg-lighter" data-test="bookmark_right_mouse_button" style="border-radius: 10px;">
                 <div class="card-header font-weight-bold p-2">
                    <h2>
                     <span class="fa fa-external-link-alt navbar-icon" style="font-size:15px"></span>
                     <layout-language data-key="openRightMouseButton"></layout-language>
                     <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                        <span class="fa fa-times"></span>
                     </button>
                     </h2>
                 </div>
                 <div class="overflow-auto">
                     <div class="card-body p-2">`

                    innerHTML += `<div class="alert alert-secondary p-1 mb-2 d-none" id="divRightMouseButtonMessage" data-testid="div_right_mouse_button_message">
                        Klik in de kaart om door te starten
                      </div>`

                    let isVisible = 'd-none'
                    if(!getMapClickMarker()) {
                        isVisible = ''
                    }
                    innerHTML += `<div class="alert alert-secondary p-1 mb-2 ${isVisible}" id="divRightMouseButtonMessageStart">
                        Kies een doorstartoptie en klik daarna in de kaart
                      </div>`

                const welcomeButtons = settings.buttons[0]
                for (const [key, value] of Object.entries(welcomeButtons)) {
                    innerHTML += `<right-mouse-button data-icon="ion ion-ios-arrow-forward" data-text="` + key + `" data-value="` + value + `"></right-mouse-button>`
                }

               innerHTML += `
                    </div>
                </div>
            </div>
`;

        template.innerHTML = innerHTML
        initWebComponent(this, template)

        initHideButton()
    }
}

window.customElements.define("right-mouse-button", RightMouseButtonComponent);
